import { useState, useEffect } from "react"
import { ITEM_CATEGORIES_API, ITEM_SUBCATEGORIES_API, MANAGE_CATEGORY_API, MANAGE_ITEM_API, SUBCATEGORIES_API } from "../../../../../Utilities/APIs/APIs"
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance"

function ViewItem({

    //common props
    targetID, employee

}) {

    const [item, setItem] = useState(null)
   const [categories, setCategories] = useState(null)
    const [subcategories, setSubcategories] = useState(null)
    const [itemCategories, setItemCategories] = useState(null)
    const [itemSubcategories, setItemSubcategories] = useState(null)
    
    // console.log(item)

    const axiosInstance = useAxiosInstance()

    // const [categoryOrSubcategory, setCategoryOrSubcategory] = useState('')
    // const [categoryOrSubcategoryName, setCategoryOrSubcategoryName] = useState('')

    useEffect(() => {
  
      async function fetchAndSetItem() {
      
          const {data} = await axiosInstance.get(MANAGE_ITEM_API + 'getSingleItem/' + targetID)

          setItem(data);
      }
      fetchAndSetItem()

    }, [targetID, axiosInstance])

    useState(() => {

      async function fetchAndSetCategories() {
        const {data} = await axiosInstance.get(MANAGE_CATEGORY_API)
        setCategories(data)
      }

      async function fetchAndSetItemCategories() {
        const {data} = await axiosInstance.get(ITEM_CATEGORIES_API)
        setItemCategories(data)
      }

      async function fetchAndSetSubategories() {
        const {data} = await axiosInstance.get(SUBCATEGORIES_API)
        setSubcategories(data)
      }

      async function fetchAndSetItemSubcategories() {
        const {data} = await axiosInstance.get(ITEM_SUBCATEGORIES_API)
        setItemSubcategories(data)
      }

      fetchAndSetCategories()
      fetchAndSetSubategories()
      fetchAndSetItemCategories()
      fetchAndSetItemSubcategories()

    }, [])

    return (
      <div className="crud_view_content">

        <h1>Name</h1>
        <p>{item?.name}</p>

        <h1>Description</h1>
        <p>{item?.description}</p>

        <h1>Price</h1>
        <p>{item?.price}</p>

        <h1>Availability</h1>
        <p>{item?.isAvailable === true ? 'TRUE' : 'FALSE'}</p>

        <h1>Visibility</h1>
        <p>{item?.isVisible === true ? 'TRUE' : 'FALSE'}</p>

        <h1>Category</h1>
        <p>
          {
            item?.categoryOrSubcategory === 'category'
            ?
              categories?.find(
                c => c._id === (itemCategories?.find(i => i.item === item?._id)?.category)
              )?.name
            :
              categories?.find(
                c => c._id === (subcategories?.find(
                  s => s._id === (itemSubcategories?.find(
                    i => i.item === item?._id)?.subcategory)
                  )?.category
                ))?.name
          }
        </p>

        {
          item?.categoryOrSubcategory === 'subcategory' &&
          <>
          <h1>Subcategory</h1>
          {
            subcategories?.find(
              s => s._id === (itemSubcategories?.find(i => i.item === item?._id)?.subcategory)
            )?.name
          }
          </>
        }

      </div>
    )
}

export default ViewItem